import request from '@/api/request'

//人才列表
export function recommendlist(data) {
    return request({
        url: '/api/director/user/list',
        method: 'GET',
        params: data
    })
}

//人才更多列表
export function morelist(data) {
    return request({
        url: '/api/director/user/list',
        method: 'GET',
        params: data
    })
}

//人才主页信息
export function recommendinfo(data) {
    return request({
        url: '/api/user/info',
        method: 'GET',
        params: data
    })
}

//人才检索列表
export function recommendsearch(data) {
    return request({
        url: '/api/user/select',
        method: 'GET',
        params: data
    })
}


//首页banner
export function bannerimage(data) {
    return request({
        url: '/api/banner/list',
        method: 'GET',
        params: data
    })
}

//主管主页
export function userdirectorinfo(data) {
    return request({
        url: '/api/director/info',
        method: 'GET',
        params: data
    })
}